import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPhase1Checklist = lazy(() => import("@/pages/admin/AdminPhase1Checklist"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/phase1-checklist")({
  component: () => (
    <AdminLayout requiredPermission="manage_admins">
      <AdminPhase1Checklist />
    </AdminLayout>
  ),
});
